<script setup lang="ts">
import { computed } from 'vue'

import AnomaliesTeaser from './AnomaliesTeaser.vue'

import type { DashboardWidgetEmbedProps } from '@/features/dashboards'

const props = defineProps<DashboardWidgetEmbedProps>()
const emit = defineEmits<{ count: [count: number] }>()

const workspaceIds = computed(() => {
  const candidates = props.accountWorkspaces.length > 0 ? props.accountWorkspaces : [props.wsId]
  return [
    ...new Set(
      candidates.flatMap((value) => {
        if (value === null || (typeof value === 'string' && value.trim() === '')) return []
        const numeric = Number(value)
        return Number.isFinite(numeric) ? [numeric] : []
      }),
    ),
  ]
})
</script>

<template>
  <AnomaliesTeaser
    :title="title"
    :limit="10"
    :workspace-ids="workspaceIds"
    @count="emit('count', $event)"
  />
</template>
